import React, { useEffect, useState } from "react";
import { styled, Typography, Box, Avatar } from "@mui/material";
import Logo from "../../assets/Image/logo.png";
import moment from "moment";
import Notification from "../../assets/svg/Notification";
import CustomButton from "./CustomButton";
import CreateFeed from "../CreateFeedPopup";
import { useLocation } from "react-router-dom";
import { colors } from "../../utils/colors/Index";
import PlanDetailsPopup from "../PlanDetailsPopup";

const Navbar = ({ toggleTheme, mode }) => {
  const location = useLocation().pathname;
  const [currentTime, setCurrentTime] = useState(
    moment().format("MMMM D, YYYY | dddd h:mm A")
  );
  const [open, setOpen] = useState(false);
  // const [planOpen, setPlanOpen] = useState(false);

  useEffect(() => {
    const updateClock = () => {
      setCurrentTime(moment().format("MMMM D, YYYY | dddd h:mm A"));
      setTimeout(updateClock, 1000); // Update every second
    };

    updateClock();

    return () => clearTimeout(updateClock);
  }, []);
  const handleOpen = () => setOpen(true);
  // const handlePlanOpen = () => {
  //   setPlanOpen(true);
  // };
  return (
    <Container>
      <Subcontainer sx={{ justifyContent: "flex-start" }}>
        <ImageContainer>
          <Image src={Logo} alt="Logo" />
        </ImageContainer>
      </Subcontainer>
      {location !== "/" && (
        <>
          <Subcontainer sx={{ justifyContent: "center" }}>
            <Typography variant="body1">{currentTime}</Typography>
          </Subcontainer>
          <Subcontainer sx={{ justifyContent: "flex-end", columnGap: "1rem" }}>
            {/* <CustomButton
              title="Plan Details"
              variant="outlined"
              handleClick={handlePlanOpen}
              sx={{
                outline: "1.5px solid #E8503A",
                color: colors.text.orange,
                padding: "0.3rem 1.8rem",
                fontWeight: 500,
                textTransform: "capitalize",
              }}
            /> */}
            {/* <CustomButton
              title="Add Post"
              handleClick={handleOpen}
              sx={{
                backgroundColor: "#E8503A",
                color: "white",
                padding: "0.3rem 2rem",
                textTransform: "capitalize",
              }}
            /> */}
            <Notification />
            <Avatar />
          </Subcontainer>
        </>
      )}
      <CreateFeed open={open} setOpen={setOpen} />
      {/* <PlanDetailsPopup open={planOpen} setOpen={setPlanOpen} /> */}
    </Container>
  );
};

export default Navbar;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column", // Stack items vertically on small screens
  },
}));

const Subcontainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "33.33%",
  padding: "0.5rem 1rem",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: "100%", // Full width for subcontainers on small screens
    justifyContent: "center", // Center content on small screens
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: 100,
}));

const Image = styled("img")(({ theme }) => ({
  width: "100%",
}));
